var render, staticRenderFns
import script from "./DragMultipleMixin.vue?vue&type=script&lang=ts&"
export * from "./DragMultipleMixin.vue?vue&type=script&lang=ts&"
import style0 from "./DragMultipleMixin.vue?vue&type=style&index=0&id=47f70808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f70808",
  null
  
)

export default component.exports